import { render, staticRenderFns } from "./sliderBrands.vue?vue&type=template&id=0e8075f4&scoped=true&"
import script from "./sliderBrands.vue?vue&type=script&lang=js&"
export * from "./sliderBrands.vue?vue&type=script&lang=js&"
import style0 from "./sliderBrands.vue?vue&type=style&index=0&id=0e8075f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8075f4",
  null
  
)

export default component.exports